enum PrispevokVestnikaStepEnum {
  BASIC_DATA_1 ='BASIC_DATA_1',
  DATES_2 ='DATES_2',
  RELATED_DATA_3 ='RELATED_DATA_3',
  ATTACHMENTS_4 ='ATTACHMENTS_4',
  MAIN_ATTACHMENT_5 ='MAIN_ATTACHMENT_5',
  CHECK_DATA_6 ='CHECK_DATA_6',
  CREATE_UPDATE_7 ='CREATE_UDATE_7',
}

export default PrispevokVestnikaStepEnum;
